// Dados institucionais exibidos no site e nos textos legais.
// Revise `controller` antes do lançamento: é quem responde legalmente pelo tratamento
// dos dados (LGPD art. 9º, III e IV).

export const site = {
  name: 'Poder Aberto',
  tagline: 'Uma democracia em construção.',
  description: 'Um espaço aberto para propor, discutir e construir novas possibilidades para a democracia.',
  /**
   * Descrição para buscadores e compartilhamento (página inicial). Mesmo texto da meta
   * description do index.html e do manifesto do app (vite.config.ts).
   */
  searchDescription:
    'Vote, debata e proponha reformas da democracia brasileira. Plataforma cívica independente e apartidária, sem vínculo com governos, partidos ou candidaturas.',
  url: 'https://poderaberto.com',

  contactEmail: 'contato@poderaberto.com',
  privacyEmail: 'privacidade@poderaberto.com',
  moderationEmail: 'moderacao@poderaberto.com',

  /** Controlador dos dados pessoais e encarregado (LGPD art. 41). */
  controller: {
    name: 'Poder Aberto (iniciativa cívica independente)',
    document: '',
    dpoName: 'Encarregado(a) de dados do Poder Aberto',
    dpoEmail: 'privacidade@poderaberto.com',
  },

  /** Versões dos textos aceitos/consentidos. Mude a data ao alterar o texto correspondente. */
  versions: {
    terms: '2026-10-26',
    privacy: '2026-10-26',
    voteConsent: '2026-10-25',
    publicationConsent: '2026-10-25',
  },
} as const
